module.exports = __webpack_public_path__ + "static/media/btn-drop-down.3db98c82.svg";